<template>
    <svg
        viewBox="0 0 100 30"
        preserveAspectRatio="none"
        style="width:100%;height:48px;display:block"
    >
        <path
            :d="areaPath"
            fill="rgba(112, 42, 225, 0.08)"
            stroke="none"
        />
        <path
            :d="linePath"
            fill="none"
            stroke="var(--color-primary)"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
export default {
    name: 'KpiLineChart',
    props: {
        values: {
            type: Array,
            default: () => [12, 18, 14, 22, 20, 28, 26, 32],
        },
    },
    computed: {
        points() {
            const max = Math.max(...this.values, 1)
            const min = Math.min(...this.values, 0)
            const range = Math.max(max - min, 1)
            const stepX = 100 / (this.values.length - 1)
            return this.values.map((v, i) => ({
                x: i * stepX,
                y: 28 - ((v - min) / range) * 24,
            }))
        },
        linePath() {
            return this.points
                .map((p, i) => `${i === 0 ? 'M' : 'L'}${p.x.toFixed(2)},${p.y.toFixed(2)}`)
                .join(' ')
        },
        areaPath() {
            const line = this.linePath
            const last = this.points[this.points.length - 1]
            return `${line} L${last.x.toFixed(2)},30 L0,30 Z`
        },
    },
}
</script>
